declare const angular: ng.IAngularStatic;
declare const $: any;
export class carouselController {
  id: any;
  BaseUrlPage: any;
  apiType: any;
  items: any[];
  CurrentPage: any;
  apiData: any;
  apiMethod: any;
  apiUrl: string;
  AjaxLoading: boolean;
  TotalItems;
  option: any;
  constructor(
    private $rootScope,
    private CarouselService,
    private $mPath,
    private $filter,
    private $timeout
  ) {
    'ngInject';
  }
  $onInit() {
    this.AjaxLoading = true;
    this.$mPath.get().then(response => {
      this.BaseUrlPage = response;
      this.LoadData(1);
    });
  }
  LoadData(PageNumber) {
    var apiUrl = this.apiUrl + '&PageNumber=' + PageNumber;
    this.CarouselService.get(apiUrl, this.apiMethod, this.apiData).then(
      data => {
        this.TotalItems = data.data.TotalItems || 100;
        this.CurrentPage = PageNumber || 1;
        this.items = [];
        switch (this.apiType) {
          case 'Search':
            this.searchForEach(data);
            break;
          case 'Product':
            this.productForEach(data);
            break;
          case 'Category':
            this.categoryForEach(data);
            break;
        }
        // this.option = {
        //   loop: true,
        //   margin: 10,
        //   responsiveClass: true,
        //   responsive: {
        //     0: {
        //       items: 1,
        //       nav: true
        //     },
        //     600: {
        //       items: 1,
        //       nav: false
        //     },
        //     1000: {
        //       items: 1,
        //       nav: true,
        //       loop: false
        //     }
        //   }
        // }
        let component_width = $(`#ecb_carousel${this.id}`).width();
        let items = Math.floor(component_width / 310);
        console.log(items);
        this.option = {
          items: items,
          rtl: true,
          dots: false,
          nav: false,
          loop: true,
          slideBy: 'page',
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          responsive: {
            0: {
              items: 1
            },
            460: {
              items: Math.floor(items / 3)
            },
            768: {
              items: Math.floor(items / 2)
            },
            1200: {
              items: items
            }
          }
        };
        this.$timeout(() => {
          // $(`#ecb_carousel${this.id}`).owlCarousel();
          this.AjaxLoading = false;
        }, 10);
      }
    );
  }
  searchForEach(data) {
    data.data.Products.map(item => {
      item.url =
        this.BaseUrlPage.StoreProductDetail + '/pID/' + item.ProductID + '/';
    });
    this.items = data.data.Products;
  }

  productForEach(data) {
    data.data.ProductList.map(item => {
      item.url =
        this.BaseUrlPage.StoreProductDetail + '/pID/' + item.ProductID + '/';
    });
    this.items = data.data.ProductList;
  }

  categoryForEach(data) {
    angular.forEach(data.data, function(val, key) {
      var item = {
        ImageFullPath: val.ImageUrl,
        url: this.BaseUrlPage.StoreListByCat + '/#/catID/' + val.CategoryID,
        Name: val.CategoryName
        // Price:  $filter('currency')(val.Meta_MinPrice,'',0) +' تومان '
      };
      this.items.push(item);
    });
    this.$rootScope.$emit('endLoading', this.items);
  }
}



// WEBPACK FOOTER //
// ./src/components/carousel/carousel.controller.ts